export function normalizeUserQuantity(q) {
  return {
    id: q.id,
    nodeId: `uq${q.id}`,

    type: "userQuantity",

    code: q.code,
    title: q.title,
    conversionFactor: q.conversion_factor,
    goldType: q.gold_type,
    maxAmount: q.max_amount,
    minAmount: q.min_amount,
    quantityDefinitionUnit: q.quantity_definition_unit,
    showPrice: q.show_price ?? false,
    prices: {
      buy: {
        price: q.buy_price?.price || null,
        createdOn: q.buy_price.created_on,
      },

      sell: {
        price: q.sell_price?.price || null,
        createdOn: q.sell_price.created_on,
      },
    },

    active: {
      buy: {
        'isActive': q?.buy_price?.is_active,
      },
      sell: {
        'isActive': q?.sell_price?.is_active,
      }
    },

    isActive: q.is_active,
    isMelted: q.is_melted,
  };
}